// src/components/Home.tsx
import React, { useEffect, useState } from 'react';
import { useAuth } from '../AuthContext';
import { useNavigate, useLocation } from 'react-router-dom';


const EmailVerified: React.FC = () => {
    const navigate = useNavigate();
    const location = useLocation();

    const getSuccess = (): Boolean => {
        const params = new URLSearchParams(location.search);
        return Boolean(params.get('success'));
    }

    const [success, _] = useState<Boolean>(getSuccess());

    return (
        <div>
            <div id="content-pane">
                {success && <p>Email verification succeeded. Please log in to continue.</p>}
                {!success && <p>Email verification failed. Please log in to retry.</p>}
            </div>
        </div>
    );
}

export default EmailVerified;
